export default { commitHash: '548e422', version: '5.0.0-2-g548e422' };
